import type { ReactElement, ReactNode } from 'react';
import styles from './VenueImage.module.scss';
import type { PreviewVenue } from '../types';
import { VenueLink } from '../VenueLink';
import { PreviewImages } from 'common/components/previewImages/PreviewImages';

export function VenueImage(props: {
  onClickVenueLink: undefined | (() => void);
  openInNewTab: boolean;
  venue: PreviewVenue;
  featuredVenueIcon?: ReactNode;
}): ReactElement {
  const { venue, onClickVenueLink, openInNewTab, featuredVenueIcon } = props;

  return (
    <div className={styles.imageContainer}>
      {featuredVenueIcon}
      <PreviewImages
        images={venue.preview_images}
        linkWrapper={({ children }) => (
          <VenueLink
            venue={venue}
            openInNewTab={openInNewTab}
            onClickVenueLink={onClickVenueLink}
          >
            {children}
          </VenueLink>
        )}
      />
    </div>
  );
}
